import React from 'react'
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import ViewTypeField from "./ViewTypeField";
import AdminColumnToggle from "./AdminColumnToggle";
import GlobalFilters from "./GlobalFilters";
import ActionButtons from "./ActionButtons";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";

function SearchField(props) {
  const {
    fullScreen,
    open,
    handleClose,
    viewType,
    onViewTypeSelect,
    childViewType,
    availableColumns,
    onColumnChange,
    checkedColumns,
    availableChildColumns,
    checkedChildColumns,
    limit,
    onLimitSelect,
    country,
    onCountrySelect,
    showChilds,
    toggleShowChildren,
    showChildHeader,
    toggleChildHeader,
    filters,
    cacheUpdating,
    onFileExport,
    updateStatsCache,
    update
  } = props

  return <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
      maxWidth={"lg"}
  >
    <DialogTitle id="responsive-dialog-title">Settings</DialogTitle>
    <DialogContent>
      <div className="row">
        <div className="col-12 col-sm-6">
          <ViewTypeField viewType={viewType}
                         onViewTypeSelect={onViewTypeSelect}
                         childViewType={childViewType}/>
        </div>
        <div className="col-12 col-sm-6">
          <div className='mb-3 mr-2 float-left'>
            <AdminColumnToggle
                alias={viewType + 'VisibleColumns'}
                columns={availableColumns}
                icon={'fas fa-list-ol'}
                label={viewType}
                onChange={onColumnChange}
                checkedColumns={checkedColumns}
            />
          </div>
          <div className='mb-3 float-left'>
            <AdminColumnToggle
                alias={childViewType + 'VisibleColumns'}
                icon={'fas fa-list'}
                label={childViewType}
                columns={availableChildColumns}
                onChange={onColumnChange}
                checkedColumns={checkedChildColumns}
            />
          </div>
        </div>

        <div className="col-12 col-sm-6">
          <GlobalFilters limit={limit}
                         onLimitSelect={onLimitSelect}
                         country={country}
                         onCountrySelect={onCountrySelect}/>
        </div>
        <div className="col-12 col-sm-6">
          <ActionButtons showChilds={showChilds}
                         toggleShowChildren={toggleShowChildren}
                         showChildHeader={showChildHeader}
                         toggleChildHeader={toggleChildHeader}
                         filters={filters}
                         cacheUpdating={cacheUpdating}
                         updateStatsCache={updateStatsCache}
                         onFileExport={onFileExport}
                         update={update}
          />
        </div>
      </div>
    </DialogContent>
    <DialogActions>
      <Button onClick={handleClose} color="primary" autoFocus>
        Close
      </Button>
    </DialogActions>
  </Dialog>
}

export default SearchField
